<template>
	<div v-show="hasButton" class="m-doc-handle-place">
		<div class="m-doc-handle flex-between-center">
			<div>
				<c-button v-if="moreMenu" style="padding: 0 .6em;" @click="moreMenu && moreMenu.open();">更多操作<i class="tf-tri-up" style="margin-left: .05rem; font-size: .24rem;"></i></c-button>
			</div>
			<div ref="button" class="list flex-grow flex-reverse">
				<template v-if="applicant">
					<c-button v-if="status == -1" size="detail" color="red" @click="$emit('delete')">删除</c-button>
					<c-button v-if="status == -1" size="detail" @click="$emit('edit')">编辑</c-button>
					<c-button v-if="status == 1" size="detail" color="red" @click="cancelHandle">撤销</c-button>
					<c-button v-if="status == 3 || status == 4" size="detail" @click="$emit('edit')">重新发起</c-button>
				</template>

				<template v-if="approver && status == 1">
					<c-button size="detail" color="main" @click="approveHandle">审批</c-button>
					<c-button size="detail" color="red" @click="rejectHandle">驳回</c-button>
				</template>

				<slot></slot>
			</div>
		</div>

		<slot v-if="$slots.more" name="more"></slot>
	</div>
</template>

<script>
	export default {
		name: 'docHandle',

		props: {
			order: [String, Number],
			flow: [String, Number],
			status: [String, Number],
			applicant: Boolean,
			approver: Boolean
		},
		
		data() {
			return {
				hasButton: false,
				moreMenu: null
			}
		},

		mounted() {
			this.updatedHandle();
		},

		updated() {
			this.updatedHandle();
		},

		beforeDestroy() {
			clearTimeout(this._timer);
		},

		methods: {
			init(data) {
				this._transaction = data;
				let $base = this.$parent.$children.find(item => item.$options.name == 'docBase');
				$base && this.$nextTick(() => {
					$base.status = this.status;
				});
			},

			updatedHandle() {
				this.$nextTick(() => {
					this.hasButton = this.$refs.button.children.length > 0;
					this.moreMenu = this.$children.find(item => item.$options.name == 'cMenu');
				});
			},

			approveHandle() {
				new Promise(resolve => {
					if (!this._transaction.approver || !this._transaction.approver.length) {
						this.$confirm({
							message: '确定要审核通过吗？',
							resolve
						});
					} else {
						this.globalDialog('flowApprove', {
							data: {
								approver: this._transaction.approver
							}
						}, resolve);
					}
				}).then((data = {}) => {
					this.request({
						url: '/flow/transaction/approve',
						data: {
							executeState: 1,
							formId: this._transaction.formId,
							restart: this._transaction.restart,
							employeeId: data.approver,
							copyEmpId: data.carbon
						},
						loading: true,
						success: () => {
							this.$message({
								message: '审批成功'
							});
							this.updateHandle();
						}
					});
				});
			},

			rejectHandle() {
				this.globalDialog('flowApprove', {
					props: {
						reject: true
					}
				}, data => {
					this.request({
						url: '/flow/transaction/approve',
						data: {
							executeState: 9,
							formId: this._transaction.formId,
							remark: data.remark
						},
						loading: true,
						success: () => {
							this.$message({
								message: '驳回成功'
							});
							this.updateHandle();
						}
					});
				});
			},

			cancelHandle() {
				this.$confirm({
					message: '确定要撤销该单据吗',
					resolve: () => {
						this.request({
							url: '/workflow/order/withdraw',
							data: {
								order_type: this.flow,
								order_id: this.order
							},
							loading: true,
							success: () => {
								this.$message({
									message: '撤销成功'
								});
								this.updateHandle();
							}
						});
					}
				});
			},

			updateHandle() {
				this.$emit('update');
				this._timer = setTimeout(() => {
					this.$emit('update');
					let $log = this.$parent.$children.find(item => item.$options.name == 'docLog');
					console.log($log)
					$log && $log.update();
				}, 2000);
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-doc-handle {
		z-index: 90;
		position: fixed;
		left: 0;
		right: 0;
		bottom: 0;
		height: 1.2rem;
		padding: 0 .24rem var(--safe-area);
		background: #fff;
		box-shadow: 0 -.02rem 0 0 #eee;

		&-place {
			height: 1.2rem;
			padding-bottom: var(--safe-area);
		}
		
		.more {
			font-size: .3rem;
			color: #999;
		}
		
		.list {
			gap: .12rem;
		}
	}
</style>
